module.exports = __webpack_public_path__ + "static/media/madrassa10.90c49373.webp";